var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-dialog',{attrs:{"show-dialog":_vm.showDialog,"text":"Fault Monitor","on-close":_vm.handleClose,"width":400}},[(_vm.showDialog)?[_c('asc-fault-monitor-alert',{attrs:{"definition":_vm.definition,"loading":_vm.loading}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }